


















































import { Component, Prop, Vue } from "vue-property-decorator";
import { userLogin } from "@/utils/auth";

@Component
export default class SiteLayout extends Vue {
	/// Properties
	@Prop({default: false})
	isDark!: boolean;
	
	/** Attributs */
	isLoading = false;

	/** Méthodes */
	async handleLogin() {
		this.isLoading = true;
		try {
			await userLogin(this.$router);
		}
		catch (err) {
			this.handleAPIError(err);
			this.isLoading = false;
		}

	}
}
